import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PdfLinkActions from "src/components/PdfLinkActions";
import { strfdate } from "src/utils/dates";

export default function OutboundChargesHeader({ inventoryRequest }) {
  const orderNumber = `${inventoryRequest.workOrderNumber}${
    inventoryRequest.revisionNumber && inventoryRequest.revisionNumber !== "0"
      ? `.${inventoryRequest.revisionNumber}`
      : ""
  }`;

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      mt={2}
      flexDirection={{ xs: "column", sm: "row" }}
      gap={1}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Typography fontWeight={500}>{orderNumber}</Typography>
        <PdfLinkActions
          resourceType="inventory_request_pdfs"
          resourceId={inventoryRequest?.id}
          sx={{
            textTransform: "none",
            fontSize: 12,
            py: 0.2,
            px: 1,
            minWidth: "auto",
            height: 25,
            borderRadius: 10,
          }}
        />
      </Box>
      <Typography fontWeight={500}>
        Need By: {strfdate(inventoryRequest.deliveryDate)}
      </Typography>
    </Box>
  );
}

